module.exports = __webpack_public_path__ + "privateAssetAGSConeChart.a997d7ec3996ccffd57ba3dca3aae9ff.svg";